import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardNote, SaveDashboardNote } from '@ddv/dashboards';
import { Client, FuzzyDates, UserPreferences } from '@ddv/models';
import { FuzzyDate } from '@hs/ui-core-date';
import { Fund } from '@hs/ui-core-fund';

@Component({
    selector: 'app-dashboard-bar',
    templateUrl: 'dashboard-bar.component.html',
    styleUrls: ['dashboard-bar.component.scss'],
    standalone: false,
})
export class DashboardBarComponent {
    @Input() dashboardNote: DashboardNote | undefined;
    @Input() dashboardId: string | undefined;
    @Input() inPresentationMode = false;
    @Input() isGlobal = false;
    @Input() isGlobalEditPartial = false;
    @Input() fuzzyDates: FuzzyDates = new FuzzyDates();
    @Input() ccFuzzyDates: FuzzyDate[] = [];
    @Input() clients: Client[] = [];
    @Input() funds: Fund[] = [];
    @Input() userPreferences: UserPreferences | undefined;

    @Output() deleteDashboardNote = new EventEmitter<void>();
    @Output() saveDashboardNote = new EventEmitter<SaveDashboardNote>();
    @Output() filtersRemoved = new EventEmitter<string[]>();

    protected onDeleteDashboardNote(): void {
        this.deleteDashboardNote.emit();
    }

    protected onSaveDashboardNote(saveDashboardNote: SaveDashboardNote): void {
        this.saveDashboardNote.emit(saveDashboardNote);
    }
}
